"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = exports.convertToPossibleTypes = exports.importQuery = void 0;
const core_1 = require("@rxdi/core");
function importQuery(search) {
    let result;
    const DOCUMENTS = core_1.Container.get('graphql-documents');
    Object.keys(DOCUMENTS).filter((doc) => {
        if (doc.indexOf(search) !== -1) {
            result = DOCUMENTS[doc];
        }
    });
    if (!result) {
        console.error(`Missing query: ${search}`);
        return search;
    }
    return result;
}
exports.importQuery = importQuery;
const convertToPossibleTypes = (introspectionQuery) => introspectionQuery.__schema.types.reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr.name]: curr.possibleTypes.map((type) => type.name) })), {});
exports.convertToPossibleTypes = convertToPossibleTypes;
/* Utility function helping us to get a new object using the apollo-store */
const deepCopy = (state) => JSON.parse(JSON.stringify(state));
exports.deepCopy = deepCopy;
